module.exports = __webpack_public_path__ + "static/media/compass.200594de.svg";